const WINDOW_MS = 30 * 60 * 1000;
const prefix = "collectie-join-visit:";
interface Storage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}
// A short-lived correlation key, not an identity or authentication credential.
// If storage is unavailable, joining still works; that visit is unmeasured.
export function joinVisitId(
  slug: string,
  storage: Storage,
  now = Date.now(),
): string | undefined {
  try {
    const key = prefix + slug;
    const raw = storage.getItem(key);
    if (raw) {
      const saved = JSON.parse(raw) as { id?: unknown; startedAt?: unknown };
      if (
        typeof saved.id === "string" &&
        /^[0-9a-f-]{36}$/i.test(saved.id) &&
        typeof saved.startedAt === "number" &&
        saved.startedAt <= now &&
        now - saved.startedAt < WINDOW_MS
      )
        return saved.id;
    }
    const id = crypto.randomUUID();
    storage.setItem(key, JSON.stringify({ id, startedAt: now }));
    return id;
  } catch {
    return undefined;
  }
}
export function browserJoinVisitId(slug: string): string | undefined {
  try {
    return joinVisitId(slug, window.sessionStorage);
  } catch {
    return undefined;
  }
}
export function applePassUrl(slug: string): string {
  return `/v1/consumer/wallet/apple/pass?locationSlug=${encodeURIComponent(slug)}`;
}
